<template>

	<div>

		<section class="outer-pad">

			<h2 class="title">Stats</h2>

			<Table
				v-if="reportFetched"
				:headings="headings"
				:items="items" 
				:searchSetup="searchSetup"
				:loading="loadingTable"
				name="admin-analysis-credits"
				class="stats-table"
				@search="search"
				@clear="clearSearch"
			/>

			<h2 class="title">Credits</h2>

			<form class="form" @submit.prevent="saveSettings">

				<h3 class="title">Allocation</h3>

				<span
					v-for="(category, categoryIndex) in categoriesMain" 
					:key="'category-main-'+categoryIndex"
				>

					<FormInput type="number" :label="category.label" v-model="info[category.name]" :name="category.name" :errors="errors" @has-internal-errors="hasInternalErrors" />

				</span>

				<h3 class="title">Cost Per Service</h3>

				<span
					v-for="(category, categoryIndex) in categories" 
					:key="'category-'+categoryIndex"
				>

					<FormInput type="number" :label="category.label" v-model="info[category.name]" :name="category.name" :errors="errors" @has-internal-errors="hasInternalErrors" />

				</span>

				<span class="large-button" @click="saveSettings">Save Settings</span>

			</form>

		</section>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import general from '../../utils/general'
import ApiService from '../../services/api.service'
import FormInput from './../../components/Form/Input.vue'
import Table from '../../components/Table.vue'
export default {
	name: 'AdminAnalysisCredits',
	components: {
		FormInput,
		Table
	},
	data() {
		return {
			info: {},
			errors: {},
			okToSubmit: false,
			categories: [],
			categoriesMain: [],
			reportFetched: false,
			headings: {},
			items: [],
			loadingTable: false,
			searchSetup: {},
			tableSearch: {}
		}
	},
	computed: {

		...mapState('general',['dateTimeFormat']),

		proxyList () {

			return [
				{
					_id: 'proxy_rack',
					label: 'Proxy Rack'
				},
				{
					_id: 'packet_stream',
					label: 'Packet Stream'
				}
			]

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		saveSettings () {

			this.updateLoadingText("Saving...");

			ApiService.post( 'admin/analysis-credits', this.info )
			.then( function( response ) {

				this.updateLoadingText();

			}.bind(this))
			.catch( function(error) {
			
				this.updateLoadingText();

			}.bind(this));

		},
	    hasInternalErrors(a) {

	    	if ( typeof this.errors[a.name] !== 'undefined' ) delete this.errors[a.name];

	    	if ( a.error ) this.errors[a.name] = a.error;

	    	this.okToSubmit = true;

	    	Object.keys( this.errors ).forEach( function(error) {

	    		this.okToSubmit = this.errors[error].error !== false ? false : this.okToSubmit;

	    	}.bind(this));

	    },
		fetchTracking () {

			this.loadingTable = true;

			ApiService.post( 'admin/analysis-credits/report', this.tableSearch )
			.then( function( response ) {

				this.items = response.data.items;

				if ( !this.reportFetched ) {

					this.headings = response.data.headings;
					this.searchSetup = response.data.searchSetup;

				}
				else {

					if ( response.data.costPer ) this.searchSetup.costPer = response.data.costPer;
					else if ( this.searchSetup.costPer ) delete this.searchSetup.costPer;

				}

				this.reportFetched = true;
				this.loadingTable = false;

			}.bind(this))
			.catch( function(error) {
			
				this.loadingTable = false;

			}.bind(this));


		},

		clearSearch () {

			Vue.set( this, 'tableSearch', {} );
			this.fetchTracking ();

		},

		search(info) {

			Vue.set( this, 'tableSearch', info );
			this.fetchTracking ();

		},
		
	},
	created() {

		this.updateLoadingText("Fetching Current Credits");

		ApiService.get( 'admin/analysis-credits' )
		.then( function( response ) {

			this.updateLoadingText();

			response.data.forEach ( function (category) {

				this.info[category.name] = category.credits || 0;

				if ( category.mainSetting ) 
					this.categoriesMain.push(category);
				else 
					this.categories.push(category);

			}.bind(this));

		}.bind(this))
		.catch( function(error) {
		
			this.updateLoadingText();

		}.bind(this));

		this.fetchTracking();

	}
}
</script>
<style lang="less" scoped>
.title {
	margin-bottom: 20px;
}
.stats-table {
	margin-bottom: 30px;
}
</style>